import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';

export enum MenuItemType {
    button = 'button',
    separator = 'separator',
    text = 'text',
}

@Component({
    selector: 'menu-item',
    template: '<ng-template #template><ng-content></ng-content></ng-template>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
/* eslint-disable @angular-eslint/component-class-suffix */
export class MenuItem {
    @Input() id: string;
    @Input() type: MenuItemType;
    @Input() tooltip: string;
    @Output() action = new EventEmitter<MouseEvent>();
    @ViewChild('template', {static: true}) template: TemplateRef<any>;
}

/* eslint-enable @angular-eslint/component-class-suffix */
